import { Box, Card, CardHorizontalDivider, Container, Flex, Loader } from "@eworkit/iris";
import React, { useContext } from "react";
import { FC } from "react";

import { ConsultantProfileContext, UserContext } from "@/components/User";
import { IConsultantProfile, fetchConsultantProfile } from "@/data/consultant-profiles";
import { useFetcher } from "@/hooks/http";

import { DashboardCompanyProfile, DashboardConsultantProfile } from "../components";

interface DashboardProfileSectionProps {}

export const DashboardProfileSection: FC<DashboardProfileSectionProps> = () => {
  const { updateContextUserProfile, contextCompany } = useContext(UserContext);
  const ConsultantProfile = useContext(ConsultantProfileContext);

  const profileFetcher = useFetcher(
    fetchConsultantProfile,
    {
      consultantProfileId: ConsultantProfile.currentProfileId,
      companyId: ConsultantProfile.currentCompanyId,
    },
    [ConsultantProfile.currentProfileId, ConsultantProfile.currentCompanyId],
  );

  const handleProfileUpdate = (payload: IConsultantProfile) => {
    profileFetcher.updatePayload(payload);
    updateContextUserProfile(payload);
  };

  const profile = profileFetcher.payload;
  const isLoaded = !profileFetcher.working && profile;

  return (
    <Card as={Box} gridColumn={["1 / 5", null, null, "1 / 3"]}>
      <Box py={["0", null, null, "xs"]}>
        {isLoaded ? (
          <React.Fragment>
            <DashboardConsultantProfile
              profile={profile}
              completeness={profile.completeness}
              onProfileUpdate={handleProfileUpdate}
            />
            {contextCompany && (
              <React.Fragment>
                <CardHorizontalDivider />
                <DashboardCompanyProfile company={contextCompany} />
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <Container as={Flex} alignItems="center" justifyContent="center" sx={{ minHeight: `150px` }}>
            <Loader size="xl" />
          </Container>
        )}
      </Box>
    </Card>
  );
};
